package com.ashes.dev.ai.weather.weathershow

import kotlin.js.Date

actual fun getCurrentTime(): String {
    val date = Date()
    val h = date.getHours().toString().padStart(2, '0')
    val m = date.getMinutes().toString().padStart(2, '0')
    val s = date.getSeconds().toString().padStart(2, '0')
    return "$h:$m:$s"
}

actual fun getFormattedDate(dateString: String): String {
    return dateString.split("-").last()
}
